import { render } from "./KryptonBrandButtons.vue?vue&type=template&id=5d4bb9fd&lang=pug"
import script from "./KryptonBrandButtons.vue?vue&type=script&lang=js"
export * from "./KryptonBrandButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__